module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.448c34a56d699c29117a.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bootstrap/fonts/glyphicons-halflings-regular.woff2
// module id = 1195
// module chunks = 8